import React from "react";
import { Link } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import {
  FaFacebookF,
  FaLinkedinIn,
  FaBehance,
  FaPhone,
  FaFax,
  FaInstagram,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { slugify } from "../../utils";
import ServiceData from "../../data/service/ServiceMain.json";

const AllData = ServiceData;

const OffcanvasMenu = ({ offcanvasShow, offcanvasHide, itemShow }) => {
  return (
    <Offcanvas
      show={offcanvasShow}
      onHide={offcanvasHide}
      placement="end"
      className="header-offcanvasmenu"
    >
      <Offcanvas.Header closeButton></Offcanvas.Header>
      <Offcanvas.Body>
        {/* <form action="#" className="side-nav-search-form">
                    <div className="form-group">
                        <input type="text" className="search-field" name="search-field" placeholder="Search..." />
                        <button className="side-nav-search-btn"><i className="fas fa-search"></i></button>
                    </div>
                </form> */}
        <div className="row ">
          <div className="col-lg-5 col-xl-6">
            <ul className="main-navigation list-unstyled">
              {AllData.slice(0, itemShow).map((data, index) => (
                <li key={index}>
                  <Link
                    to={
                      process.env.PUBLIC_URL +
                      `/service-details/${slugify(data.title)}`
                    }
                  >
                    {data.title}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-7 col-xl-6">
            <div className="contact-info-wrap">
              <div className="contact-inner">
                <address className="address">
                  <span className="title">Contact Information</span>
                  <p>
                    <strong>Canada Office (HQ):</strong> 600 Matheson Blvd W,
                    Unit 5 Inside Venture X, Mississauga, ON, LCR 4C1.
                  </p>
                  <p>
                    <strong>India Office (BO):</strong> Main Market, Street No.
                    8, Old Bishan Nagar, Patiala, Punjab 147001 India.
                  </p>
                  <p><strong>Australia Office (BO):</strong> 10 Goodison ST North Kellyville NWS 2155.</p>
                </address>
                <address className="address">
                  <span className="title">We're Available 24/7. Call Now.</span>
                  <a href="tel:12125553333" className="tel">
                    <FaPhone />
                    Canada: +1 (437) 688-6769
                  </a>
                  <a href="tel:8884562790" className="tel">
                    <FaPhone />
                    India: +91 77172-54001
                  </a>
                  <a href="tel:12125553333" className="tel">
                    <FaPhone />
                    Australia: (+61) 45170-4518
                  </a>
                </address>
              </div>
              <div className="contact-inner">
                <h5 className="title">Find us here</h5>
                <div className="contact-social-share">
                  <ul className="social-share list-unstyled">
                    <li>
                      <a href="https://www.facebook.com/profile.php?id=61571432191294">
                        <FaFacebookF />
                      </a>
                    </li>
                    <li>
                      <a href="https://x.com/New_way_it">
                        <FaXTwitter />
                      </a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/new_way_it/">
                        <FaInstagram />
                      </a>
                    </li>
                    {/* <li>
                                            <a href="https://www.linkedin.com/"><FaLinkedinIn /></a>
                                        </li> */}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default OffcanvasMenu;
